var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_3263",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_3263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5351 81.6406V85.3144C98.5351 86.3945 97.6601 87.2676 96.582 87.2676H3.41797C2.33984 87.2676 1.46484 86.3945 1.46484 85.3144V14.6855C1.46484 13.6055 2.33984 12.7324 3.41797 12.7324H8.38281",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2188 12.7324H96.582C97.6601 12.7324 98.5351 13.6055 98.5351 14.6855V74.8047",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27734 79.0654V20.9352C9.27734 20.7195 9.45234 20.5445 9.66797 20.5445H90.332C90.5477 20.5445 90.7227 20.7195 90.7227 20.9352V79.0654C90.7227 79.281 90.5477 79.456 90.332 79.456H9.66797C9.45234 79.456 9.27734 79.281 9.27734 79.0654Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7227 44.8125H79.1445",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1484 20.5449V44.2266C60.1484 44.5488 60.4102 44.8125 60.7344 44.8125H67.3437C67.5 44.8125 67.6484 44.873 67.7578 44.9824L72.4375 49.6641",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3396 20.5449V51.1191C46.3396 52.1973 45.4648 53.0723 44.3865 53.0723H22.6133C21.535 53.0723 20.6602 52.1973 20.6602 51.1191V20.5449",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3396 32.9121H20.6602",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1658 20.5449V24.7031C39.1658 25.5664 38.4646 26.2656 37.6033 26.2656H29.4023C28.5391 26.2656 27.8398 25.5664 27.8398 24.7031V20.5449",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3396 38.1855H20.6602",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9023 79.4551V72.0195C22.9023 71.1562 23.6016 70.457 24.4648 70.457H42.5354C43.3984 70.457 44.0979 71.1562 44.0979 72.0195V79.4551",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1621 20.5449V25.4414C84.1621 26.0879 83.6387 26.6133 82.9902 26.6133H69.1328C68.4842 26.6133 67.9609 26.0879 67.9609 25.4414V20.5449",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7227 39.2715C90.3047 39.3984 89.8613 39.4648 89.4023 39.4648C86.8418 39.4648 84.7656 37.3887 84.7656 34.8281C84.7656 32.2676 86.8418 30.1914 89.4023 30.1914C89.8613 30.1914 90.3047 30.2578 90.7227 30.3848",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7246 71.2715H86.1094C85.2461 71.2715 84.5469 70.5703 84.5469 69.709V57.2519C84.5469 56.3887 85.2461 55.6894 86.1094 55.6894H90.7246",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1504 37.2402H55.4023C54.9707 37.2402 54.6211 36.8906 54.6211 36.459V27.7793C54.6211 27.3476 54.9707 26.998 55.4023 26.998H60.1504",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1484 79.4551V57.0312",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7852 57.0312H62.515",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.5d9648b00d65deb48841920841bd893e.svg";
export { ForwardRef as ReactComponent };